import React, { ReactNode } from 'react'
import styled, { ThemeProvider } from 'styled-components'
import { defaultTheme } from './new/theme/theme'
import { ThemeName, useRootTheme } from './darkMode'
import { PersistentLoaderProvider } from './new/PersistentLoader'

interface Props {
  children: ReactNode
  variation?: ThemeName
}

export const ThemeProviderClean = ({ children, variation }: Props) => {
  const { theme } = useRootTheme()
  const finalTheme = variation ?? theme
  return (
    <StyledNewColorScheme $colorScheme={finalTheme} data-theme={finalTheme}>
      <ThemeProvider theme={defaultTheme}>
        <PersistentLoaderProvider>{children}</PersistentLoaderProvider>
      </ThemeProvider>
    </StyledNewColorScheme>
  )
}

const StyledNewColorScheme = styled.div<{ $colorScheme: ThemeName }>`
  display: contents;
  color-scheme: ${({ $colorScheme }) => $colorScheme};
`
